// extracted by mini-css-extract-plugin
export default {"box":"Input_box__8gunV","box__description":"Input_box__description__QxCct","box__input":"Input_box__input__GX55C"};